import { proxy } from "../../valtio/index.js";
const state = proxy({
  logging: "disabled",
  schedulerInterval: 10 * 60 * 1e3,
  // 10 seconds
  urlChangeDelay: 1e4
  // 10 minutes
});
function setLogging(next) {
  state.logging = next;
}
function getLoggingEnabled() {
  return state.logging === "enabled";
}
function setUrlChangeDelayId(next) {
  state.urlChangeDelayId = next;
}
function getUrlChangeDelayId() {
  return state.urlChangeDelayId;
}
function setUrlChangeDelay(next) {
  state.urlChangeDelay = next;
}
function getUrlChangeDelay() {
  return state.urlChangeDelay;
}
function setSchedulerIntervalId(next) {
  state.schedulerIntervalId = next;
}
function getSchedulerIntervalId() {
  return state.schedulerIntervalId;
}
function setSchedulerInterval(next) {
  state.schedulerInterval = next;
}
function getSchedulerInterval() {
  return state.schedulerInterval;
}
function setLicenseInfo(next) {
  state.licenseInfo = next;
}
function getLicenseInfo() {
  return state.licenseInfo;
}
export {
  getLicenseInfo,
  getLoggingEnabled,
  getSchedulerInterval,
  getSchedulerIntervalId,
  getUrlChangeDelay,
  getUrlChangeDelayId,
  setLicenseInfo,
  setLogging,
  setSchedulerInterval,
  setSchedulerIntervalId,
  setUrlChangeDelay,
  setUrlChangeDelayId
};
//# sourceMappingURL=store.js.map
